import React, { useEffect, useRef, useState } from "react";
import WebLinkButton from "../Buttons/WebLinkButton";
import DialogFlowButton from "../Buttons/DialogFlowButton";
import MessageButton from "../Buttons/MessageButton";
import iconConsultant from "../../../../assets/icon_consultant.svg";
import { formatTimeAMHHMM } from "../../../../utils";
import { useNavigate, useParams } from "react-router-dom";
import PhoneButton from "../Buttons/PhoneButton";
import InternalLinkButton from "../Buttons/InternalLinkButton";
import iconTelWh from "../../../../assets/icon_tel_wh.svg";
import useSelectBrand from "../../../../hooks/styles/useSelectBrand";
import FileUploadButton from "../Buttons/FileUploadButton";
import ImageModal from "../Modal/ImageModal";
import { FaRegTrashAlt } from "react-icons/fa";
import useFileUpload from "../../hooks/agent/useFileUpload";
import FileUploadModal from "../Modal/FileUploadModal";
import FileUpload from "../agent/FileUpload";
import useReactGASend from "../../../../hooks/useReactGASend";
import ChatUserIcon from "./../Message/ChatUserIcon";
import ChatTimestamp from "../Message/ChatTimestamp";
import ChatCard from "../Message/ChatCard";
import ChatMessage from "../Message/ChatMessage";
import ChatMessageImg from "./../Message/ChatMessageImg";
import SystemMessage from "./../Message/SystemMessage";
import CloseMessage from "./../Message/CloseMessage";
import ChatMessageOg from "./../Message/ChatMessageOg";
import useAssignTime from "../../hooks/agent/useAssignTime";
import MessageErrorIcon from "./MessageErrorIcon";

// 버튼 컴포넌트 렌더링 함수
const renderButton = (props, index) => {
  const {
    action,
    label,
    value,
    type,
    navigate,
    isAgentChat,
    openFileModal,
    handleClick,
  } = props;

  const commonProps = { label };

  switch (action) {
    case "webLink":
      return <WebLinkButton {...commonProps} href={value} />;
    case "dialogFlowButton":
      return (
        <DialogFlowButton
          {...commonProps}
          key={index}
          type={type}
          onClick={() => handleDialogFlowClick(props)}
          isAgentChat={isAgentChat}
        />
      );
    case "message":
      return (
        <MessageButton
          {...commonProps}
          key={index}
          onClick={
            () => {
              handleClick();
            }
          }
        />
      );
    case "STORE_PHONE_NUMBER":
    case "phone":
      return <PhoneButton {...commonProps} key={index} href={value} />;
    case "EMART_PRODUCT_SEARCH":
      return <InternalLinkButton {...commonProps} key={index} href="/search" />;
    case "SERVICE_CENTER":
      return (
        <InternalLinkButton
          {...commonProps}
          key={index}
          href="/after-service"
        />
      );
    case "NOTICE":
      return <InternalLinkButton {...commonProps} key={index} href="/notice" />;
    case "GIFT-CARD":
      return (
        <InternalLinkButton {...commonProps} key={index} href="/gift-card" />
      );
    case "LOST_FOUND":
      return <InternalLinkButton {...commonProps} key={index} href="/lost" />;
    case "SERVICE-UNAVAILABLE":
      return <InternalLinkButton {...commonProps} key={index} href="/service-unavailable" />;
    case "UNIVERSE-CLUB":
      return (
        <InternalLinkButton
          {...commonProps}
          key={index}
          href="/universe-club"
        />
      );
    case "TRADERS_ROADSHOW":
      return (
        <InternalLinkButton {...commonProps} key={index} href="/store-news" />
      );
    case "REFUND":
      return <InternalLinkButton {...commonProps} key={index} href="/refund" />;
    case "FLYERS":
      return <InternalLinkButton {...commonProps} key={index} href="/flyers" />;
    case "file":
      return (
        <FileUploadButton
          {...commonProps}
          key={index}
          onClick={openFileModal}
        />
      );
    default:
      return null;
  }
};

const handleDialogFlowClick = ({ label, value, sessionId, search }) => {
  search({
    message: `{"type":"DIALOG_FLOW_EVENT","message":"${label}","value":"${value}","sessionId":"${sessionId}"}`,
  });
};

const Message = ({
  messageMap,
  search = () => {},
  userId,
  closedForCall,
  transferNumber,
  closedbyAgent,
  openCloseChatModal,
  onHandleAgree,
  fileModalIsOpen,
  openFileModal,
  closeFileModal,
  handleFileChange,
  fileInputRef,
  handleDeleteMessage,
  messages
}) => {
  const { agent } = useParams();
  const isAgentChat = agent === "agent";
  const navigate = useNavigate();
  const { color, hex } = useSelectBrand();
  const scrollRef = useRef();
  const { makeEventTrackFn } = useReactGASend();
  const { handleClick } = useAssignTime();

  useEffect(() => {
    if (messageMap?.length > 1) {
      const scrollHeight = scrollRef.current?.scrollHeight || 0;
      window.scrollTo({ top: scrollHeight, behavior: "smooth" });
    }
  }, [messageMap]);

  const [imgModalIsOpen, setImgModalIsOpen] = useState(false);
  const [imgSrc, setImgSrc] = useState(false);
  const [messageId, setMessageId] = useState(null);
  const [isUser, setIsUser] = useState(null);

  const handleVoiceAgentClick = () => {
    makeEventTrackFn({
      category: "event",
      action: "상담사 전화 연결(상담사 전화 연결)",
      body: { data_btn_nm: "상담사 전화 연결(상담사 전화 연결)" },
    });
    window.location.href = `tel:${transferNumber}`;
  };

  const trackButtonClick = (title, body) => {
    makeEventTrackFn({
      category: "event",
      action: `${title}(FAQ)`,
      body,
    });
  };

  const openImgModal = ({ img, messageId, isUser }) => {
    setImgModalIsOpen(true);
    setImgSrc(img);
    setMessageId(messageId);
    setIsUser(isUser);
  };

  const closeImgModal = () => {
    setImgModalIsOpen(false);
  };

  if (!messageMap?.length) return null;

  return (
    <div ref={scrollRef}>
      {messageMap.map((msg, index) => {
        const m = messages?.find(
          (message) => message.messageId === msg.messageId
        );
        const isChatbot =
          msg.data?.role === "BOT" || msg.sender?.type === "INTRO_MESG";
        const isAgent =
          msg.sender?.userId?.startsWith("sendbird_desk_agent_id") ||
          (msg.sender?.type !== "INTRO_MESG" &&
            msg.data === "" &&
            msg.sender?.userId?.startsWith("erody"));
        const isUser =
          msg.sender?.userId === userId || msg.data?.role === "USER";

        return (
          <div key={index} className="mb-6">
            {msg.sender && (isAgent || isChatbot) && !isUser && (
              <ChatUserIcon
                iconImg={isAgent ? iconConsultant : msg.sender?.plainProfileUrl}
                nickname={isAgent ? "상담원" : msg.sender?.nickname}
                agent={isAgent}
                color={hex}
              />
            )}

            {msg.ogMetaData && (
              <ChatCard isUser={isUser} agent={isAgent} color={color}>
                <ChatMessageOg
                  title={msg.ogMetaData.title}
                  url={msg.ogMetaData.url}
                  description={msg.ogMetaData.description}
                  defaultImage={msg.ogMetaData.defaultImage}
                  onClick={() =>
                    trackButtonClick("하이퍼링크 클릭", {
                      data_btn_nm: "하이퍼링크 클릭",
                      data_btn_url: msg?.ogMetaData?.url,
                    })
                  }
                />
              </ChatCard>
            )}

            {(msg.sender || msg.data?.role) &&
              Array.isArray(msg.card) &&
              msg.card.map((item, index) => (
                <ChatCard
                  key={index}
                  isUser={isUser}
                  agent={isAgent}
                  color={color}
                >
                  {item.value.map((valueItem, valueIndex) =>
                    valueItem.type === "text" ? (
                      <ChatMessage
                        key={valueIndex}
                        message={valueItem.value}
                        search={search}
                        url={msg.ogMetaData ? msg.ogMetaData.url : undefined}
                      />
                    ) : (
                      valueItem.type === "buttons" &&
                      valueItem.value.length > 0 && (
                        <div
                          key={valueIndex}
                          className={
                            msg.sender.type === "INTRO_MESG"
                              ? "mt-2 inline-flex flex-wrap gap-1.5 mb-1.5"
                              : "mt-2 flex flex-col gap-1"
                          }
                        >
                          {valueItem.value.map((button, buttonIndex) =>
                            renderButton(
                              {
                                ...button,
                                type: msg.sender.type,
                                navigate,
                                isAgentChat,
                                openFileModal,
                                search,
                                handleClick,
                              },
                              buttonIndex
                            )
                          )}
                        </div>
                      )
                    )
                  )}
                </ChatCard>
              ))}

            {msg.type?.startsWith("image/") && (
              <ChatCard isUser={isUser} agent={isAgent} color={color}>
                <ChatMessageImg
                  img={msg.url}
                  onClick={openImgModal}
                  messageId={msg.messageId}
                  isUser={isUser}
                />
              </ChatCard>
            )}

            {msg.sender && (
              <ChatTimestamp
                time={formatTimeAMHHMM(msg?.createdAt)}
                isUser={isUser}
              />
            )}
            {/* 메시지 전송 실패 시 에러 아이콘 표시 */}
            <MessageErrorIcon message={m} isAgent={isAgent} />
            {msg.type && !msg.sender && <SystemMessage message={msg.message} />}
          </div>
        );
      })}

      {closedForCall?.closedForCall && (
        <>
          <button
            onClick={handleVoiceAgentClick}
            className="flex items-center justify-center gap-7 w-full font-semibold text-white bg-purple-700 rounded-2xl h-[52px]"
          >
            <img src={iconTelWh} alt="" />
            음성 상담원 연결
          </button>
        </>
      )}

      {closedbyAgent?.closedbyAgent && (
        <CloseMessage
          message={closedbyAgent.message}
          openCloseChatModal={openCloseChatModal}
          makeEventTrackFn={makeEventTrackFn}
        />
      )}

      <FileUploadModal
        isOpen={fileModalIsOpen}
        onRequestClose={closeFileModal}
        onHandleAgree={onHandleAgree}
      />

      <ImageModal
        isOpen={imgModalIsOpen}
        onRequestClose={closeImgModal}
        img={imgSrc}
        handleDeleteMessage={handleDeleteMessage}
        messageId={messageId}
        isUser={isUser}
      />

      <FileUpload handleFileChange={handleFileChange} ref={fileInputRef} />
    </div>
  );
};

export default Message;
